"use client";

import Link, { LinkProps } from "next/link";
import React from "react";

type LinkType = Omit<
  React.AnchorHTMLAttributes<HTMLAnchorElement>,
  keyof LinkProps
> &
  LinkProps & {
    children?: React.ReactNode;
  };

export const AnimatedLink = ({
  color = "#0369A1",
  ...props
}: LinkType & {
  color?: string;
}) => {
  return (
    <Link
      {...props}
      style={{ color, transition: "all 100ms" }}
      onMouseEnter={(e) => {
        (e.currentTarget.children[0] as HTMLElement).style.maxWidth = "100%";
      }}
      onMouseLeave={(e) => {
        (e.currentTarget.children[0] as HTMLElement).style.maxWidth = "0px";
      }}
    >
      {props.children}
      <span
        style={{
          height: "1px",
          display: "block",
          backgroundColor: color,
          maxWidth: "0px",
          transition: "all 200ms",
        }}
      />
    </Link>
  );
};
